<template>
<div>
  <div class="jumbotron">
    <div class="row mb-3">
      <h1 class="header-text">Coupon Details</h1>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Category</p>
      </div>
      <div class="col-md-4 my-auto">
        <select v-model="selectedBusinessCategory" class="form-control custom-select">
          <option v-for="cat in businessCategories" v-bind:value="cat" v-bind:key="cat.id">{{ cat }}</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">List Price<span v-if="!listPrice" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <money v-bind="moneyProperties"
                 v-bind:class="{'is-invalid': listPriceInvalid}"
                 v-model="listPrice"
                 class="form-control form-control-md square-left"></money>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Discounted Price</p>
      </div>
      <div class="col-md-9 my-auto">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <money v-bind="moneyProperties"
                 v-model="discountedPrice"
                 class="form-control form-control-md square-left"></money>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Name<span v-if="!name" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input type="text"
               v-bind:class="{'is-invalid': nameInvalid}"
               v-model="name"
               class="form-control"
               v-bind:placeholder="category === 'Discounted Service' ? 'Example: Free Water Heater Inspection' : false"
               v-bind:readonly="category === 'Discounted Price' ? true : false ">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Details<span v-if="!details" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <textarea v-model="details" v-bind:class="{'is-invalid': detailsInvalid}" class="form-control" rows="3" v-bind:placeholder="detailsExample"></textarea>
      </div>
    </div>
    <div class="row mb-3">
      <h4>Monthly Budget Details</h4>
    </div>
    <div class="row mb-3" v-if="freeClicks !== 0">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Free Clicks</p>
      </div>
      <div class="col-md-2 my-auto">
        <input type="text" readonly
               v-model="freeClicks"
               class="form-control form-control-md">
      </div>
    </div>
    <div class="row mb-3" v-if="freeClicks === 0">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Promotional Code</p>
      </div>
      <div class="col-md-7 my-auto">
          <input type="text"
                v-model="promotionalCode"
                class="form-control form-control-md">
      </div>
      <div class="col-md-2 my-auto">
            <button v-on:click="checkCode" class="btn btn-primary">Apply</button>
      </div>
    </div>
    <div class="alert-wrapper">
      <b-alert variant="warning"
               dismissible
               :show="badPromotionalCheckResponse"
               @dismissed="badPromotionalCheckResponse=false">
        {{ badPromotionalCheckResponse }}
      </b-alert>
    </div>
    <div class="row mb-3">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom"># of Clicks<span v-if="!clickLimit" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <money v-bind:precision="0"
               v-bind:class="{'is-invalid': clickLimitInvalid}"
               v-model="clickLimit"
               class="form-control form-control-md"></money>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Monthly Budget<span v-if="!monthlyBudget" class="red-text">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <money v-bind="moneyProperties"
                 v-bind:class="{'is-invalid': monthlyBudgetInvalid}"
                 v-model="monthlyBudget"
                 class="form-control form-control-md square-left"></money>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <router-link tag="button"
                     to="/profile/business/advertising/coupons/overview"
                     class="btn btn-secondary back-button">Back</router-link>
      </div>
      <div class="col-6">
        <button v-on:click="validate" class="btn btn-primary">Next</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Money } from 'v-money'

export default {
  components: {
    Money
  },
  data () {
    return {
      badPromotionalCheckResponse: null,
      couponPrice: null,
      promotionalCode: null,
      selectedBusinessCategory: null,
      moneyProperties: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },

      // Form validation variables
      clickLimitInvalid: false,
      detailsInvalid: false,
      discountedPriceInvalid: false,
      freeClicksInvalid: false,
      listPriceInvalid: false,
      monthlyBudgetInvalid: false,
      nameInvalid: false,
      selectedbusinessCategoryInvalid: false,
      formInvalid: false
    }
  },
  methods: {
    ...mapMutations('products', [
      'updateCouponName',
      'updateCouponListPrice',
      'updateCouponDiscountedPrice',
      'updateCouponDetails',
      'updateCouponFreeClicks',
      'updateCouponBudgetedClicks',
      'updateCouponBudget'
    ]),
    ...mapActions('products', [
      'checkPromotionalCode',
      'getCoupons',
      'getCouponPrice'
    ]),
    defaultName () {
      this.updateCouponName('$0 for $ListPrice of Category')
    },
    async checkCode () {
      try {
        var result = await this.checkPromotionalCode(this.promotionalCode)
        this.promotionalCode = null
        this.freeClicks = result
      } catch (error) {
        this.badPromotionalCheckResponse = error.response.data
      }
    },
    validate () {
      this.formInvalid = false
      if (!this.clickLimit) {
        this.clickLimitInvalid = true
        this.formInvalid = true
      } else {
        this.clickLimitInvalid = false
      }

      if (!this.details) {
        this.detailsInvalid = true
        this.formInvalid = true
      } else {
        this.detailsInvalid = false
      }

      if (!this.listPrice) {
        this.listPriceInvalid = true
        this.formInvalid = true
      } else {
        this.listPriceInvalid = false
      }

      if (!this.name) {
        this.nameInvalid = true
        this.formInvalid = true
      } else {
        this.nameInvalid = false
      }

      if (!this.monthlyBudget) {
        this.monthlyBudgetInvalid = true
        this.formInvalid = true
      } else {
        this.monthlyBudgetInvalid = false
      }

      if (this.formInvalid) return

      this.$router.push('/profile/business/advertising/coupons/messages')
    }
  },
  computed: {
    ...mapGetters('business', [
      'getBusinessId',
      'getSelectedServices'
    ]),
    ...mapGetters('products', [
      'getCouponBudget',
      'getCouponBudgetedClicks',
      'getCouponCategory',
      'getCouponDetails',
      'getCouponDiscountedPrice',
      'getCouponFreeClicks',
      'getCouponListPrice',
      'getCouponName'
    ]),
    businessCategories () {
      return this.getSelectedServices
    },
    category () {
      return this.getCouponCategory
    },
    clickLimit: {
      get () {
        return this.getCouponBudgetedClicks
      },
      async set (value) {
        if (value !== this.getCouponBudgetedClicks) {
          this.updateCouponBudget(value * this.couponPrice)
          this.updateCouponBudgetedClicks(value)
        }
      }
    },
    details: {
      get () {
        return this.getCouponDetails
      },
      set (value) {
        this.updateCouponDetails(value)
      }
    },
    detailsExample () {
      if (this.category === 'Discounted Price') {
        return 'Example: Get $100 of service for only $75! That\'s a $25 savings on any of our services including...'
      } else {
        return 'Example: Get a free water heater inspection with each furnace tune up.'
      }
    },
    discountedPrice: {
      get () {
        return this.getCouponDiscountedPrice
      },
      set (value) {
        if (value !== this.getCouponDiscountedPrice) {
          // Only modify name if Discounted Price coupon
          if (this.category === 'Discounted Price') {
            var name = this.getCouponName

            // Set a default name if no name specified or non-standardized name
            if (!name) {
              this.defaultName()
              name = this.getCouponName
            } else {
              var checkTokens = name.split(' ')
              if (name[0] !== '$' ||
                checkTokens[1] !== 'for' ||
                checkTokens[2][0] !== '$' ||
                checkTokens[3] !== 'of'
              ) {
                this.defaultName()
                name = this.getCouponName
              }
            }

            // Update name with discountedPrice value
            var nameTokens = name.split(' ')
            nameTokens[0] = '$' + value
            this.updateCouponName(nameTokens.join(' '))
          }

          // Update discountedPrice value
          this.updateCouponDiscountedPrice(value)
        }
      }
    },
    freeClicks: {
      get () {
        return this.getCouponFreeClicks
      },
      set (value) {
        this.updateCouponFreeClicks(value)
      }
    },
    listPrice: {
      get () {
        return this.getCouponListPrice
      },
      set (value) {
        if (value !== this.getCouponListPrice) {
          // Only modify name if List Price coupon
          if (this.category === 'Discounted Price') {
            var name = this.getCouponName

            // Set a default name if no name specified or non-standardized name
            if (!name) {
              this.defaultName()
              name = this.getCouponName
            } else {
              var checkTokens = name.split(' ')
              if (name[0] !== '$' ||
                checkTokens[1] !== 'for' ||
                checkTokens[2][0] !== '$' ||
                checkTokens[3] !== 'of'
              ) {
                this.defaultName()
                name = this.getCouponName
              }
            }

            // Update name with listPrice value
            var nameTokens = name.split(' ')
            nameTokens[2] = '$' + value
            this.updateCouponName(nameTokens.join(' '))
          }

          // Update listPrice value
          this.updateCouponListPrice(value)
        }
      }
    },
    name: {
      get () {
        return this.getCouponName
      },
      set (value) {
        this.updateCouponName(value)
      }
    },
    monthlyBudget: {
      get () {
        return this.getCouponBudget
      },
      async set (value) {
        if (value !== this.getCouponBudget) {
          this.updateCouponBudgetedClicks(Math.floor(value / this.couponPrice))
          this.updateCouponBudget(value)
        }
      }
    }
  },
  watch: {
    selectedBusinessCategory (newValue, oldValue) {
      // Only modify name if Discounted Price coupon
      if (newValue && this.category === 'Discounted Price') {
        var name = this.getCouponName

        // Set a default name if no name specified or non-standardized name
        if (!name) {
          this.defaultName()
          name = this.getCouponName
        } else {
          var checkTokens = name.split(' ')
          if (name[0] !== '$' ||
            checkTokens[1] !== 'for' ||
            checkTokens[2][0] !== '$' ||
            checkTokens[3] !== 'of'
          ) {
            this.defaultName()
            name = this.getCouponName
          }
        }

        // Update name with discountedPrice value
        var nameTokens = name.split('of ')
        nameTokens[1] = newValue
        this.updateCouponName(nameTokens.join('of '))
      }
    }
  },
  async created () {
    this.selectedBusinessCategory = this.businessCategories[0]
    this.couponPrice = await this.getCouponPrice()
  }
}
</script>

<style scoped>
.back-button {
  width: 100% !important;
}

.header-text {
  font-size: 2rem;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.square-left {
  border-radius: 0px 0.25rem 0.25rem 0px !important;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/subnavItems/Details.vue